export default __webpack_public_path__ + "static/media/summerSale.7f82604e.png";